import { render } from "./StatisticC.vue?vue&type=template&id=d7afbd2a"
import script from "./StatisticC.vue?vue&type=script&lang=js"
export * from "./StatisticC.vue?vue&type=script&lang=js"

import "./StatisticC.vue?vue&type=style&index=0&id=d7afbd2a&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__